import { styled, Box, CircularProgress } from "@mui/material";

export const ContainerTable = styled(Box)({
  width: "100%",
  // height: "100%",
});

export const TableWrapper = styled(Box)(({ noPadding }) => ({
  // height: "100%",
  marginTop: false ? "24px" : "0px",
  cursor: "pointer",

  [".rdt_TableHeadRow"]: {
    minHeight: "32px",
    backgroundColor: "#F7F7F7",
    color: "#8F9094",
    textTransform: "capitalize",
    fontFamily: "DM Sans",
    fontSize: "12px",
    fontWeight: 400,
    letterSpacing: "1px",
    lineHeight: "20px",
    border: "none",
  },
  [".rdt_TableRow"]: {
    borderBottom: "1px solid #E1E1E1",
  },
  [".rdt_TableCol"]: {
    padding: noPadding ? "0px" : "4px 8px",
    width: "120px",
  },
  [".rdt_TableCol_Sortable"]: {
    justifyContent: "space-between",

    "& > div": {
      whiteSpace: "normal",
      overflow: "visible",
    },
  },

  [".rdt_TableCell"]: {
    flexWrap: "wrap",
    rowGap: "4px",
    padding: "5px 15px 5px 0px",
    color: "#565556",
    fontFamily: "DM Sans",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "20px",
    padding: "4px 8px",
  },
}))

export const Loader = styled(CircularProgress)(({ theme }) => ({
  marginTop: "16px",
  width: "32px !important",
  height: "32px !important",
  color: "blue",
}));

export const LoaderWrapper = styled(Box)({
  paddingTop: "40px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection:"column",
  gap:"10px"
});
